import { render } from "./Articles.vue?vue&type=template&id=6722376c"
const script = {}
script.render = render

export default script